export default __webpack_public_path__ + "static/01-03-prepare-differentiate-015db5f33dda1547d184f0e700f7d1cf.mp4";